// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appName: 'Flyte Zone',
  apiRoot: 'https://flytezone-web-qa.dev.byteorbit.co/api/',
  ravenDsn: '',
  environment: 'undefined',
  version: 'undefined',
  apiCacheDuration: 5000,
  frontendRootUrl: 'https://flytezone-frontend-qa.dev.byteorbit.co',
  backendRootUrl: 'https://flytezone-web-qa.dev.byteorbit.co',
  googleMapsApiKey: 'AIzaSyCgKxI-elC09Ef6YJGVtZjCCbwYmaMA1vU',
  payFastBaseUrl: 'https://sandbox.payfast.co.za/eng',
  payFastMerchantId: '10027879',
  payFastMerchantKey: '72ra4rzxbl5e3',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
